export const loadingStatus = val => {
  return val ? 'loading' : null
}

export const className = cssClass => `refresh-button ${cssClass}`



// WEBPACK FOOTER //
// ./src/components/Elements/RefreshSearchButton/RefreshUtils.js